import MyJobsContainer from "../../Containers/MyJobs";

const MyJobs = () => {
  return <MyJobsContainer />;
};

export default MyJobs;
